import axios from 'axios'
import fetch from '@/utils/fetch'
import { getToken } from '@/utils/auth'

// 登录
export function login(data) {
  return fetch({
    url: '/api/artificial/abnl/user/auth/login',
    method: 'post',
    data
  })
}

// 绑定微信
export function userWechatBinding(data) {
  return fetch({
    url: '/api/artificial/abnl/user/auth/wechatBinding',
    method: 'post',
    data
  })
}

// 注册
export function register(data) {
  return fetch({
    url: '/api/artificial/abnl/user/auth/register',
    method: 'post',
    data
  })
}

// 修改密码
export function changePassWord(data) {
  return fetch({
    url: '/api/artificial/abnl/user/changePassword ',
    method: 'put',
    data
  })
}

// 忘记密码
export function resetPassword(data) {
  return fetch({
    url: '/api/artificial/abnl/user/auth/resetPassword',
    method: 'put',
    data
  })
}

// 忘记密码获取短信验证码
export function sendResetSms(params) {
  return fetch({
    url: '/api/artificial/abnl/user/auth/sendResetSms',
    method: 'post',
    params
  })
}

// 获取短信验证码
export function sendRegSms(params) {
  return fetch({
    url: '/api/artificial/abnl/user/auth/sendRegSms',
    method: 'post',
    params
  })
}

// 获取当前处理员信息
export function getCurrentStaff() {
  return fetch({
    url: '/api/artificial/abnl/user/getCurrent',
    method: 'get'
  })
}

// 获取当前处理员等级信息
export function getCurrentStaffLevel() {
  return fetch({
    url: '/api/artificial/abnl/user/level',
    method: 'get'
  })
}

// 获取当前处理员通联二维码
export function getThirdPartyQRCode(userId) {
  return fetch({
    url: '/api/artificial/abnl/user/account/thirdPartyQRCode',
    method: 'get',
    params: {
      userId
    }
  })
}

// 刷新token
export function refreshToken() {
  return fetch({
    url: '/api/artificial/abnl/user/auth/refresh',
    method: 'post'
  })
}

// 用户退出登录时在线状态不变
export function destoryToken() {
  return fetch({
    url: '/api/artificial/abnl/user/auth/destroyToken',
    method: 'post'
  })
}

// 检查离职申请条件
export function checkLeaveCondition(params) {
  return fetch({
    url: '/api/artificial/abnl/user/leave/checkLeaveCondition',
    method: 'get',
    params
  })
}

// 离职申请
export function partPersonLeaveApply(data) {
  return fetch({
    url: '/api/artificial/abnl/user/leave/partPersonLeaveApply',
    method: 'post',
    data
  })
}

// 获取验证码图片
export function getCodeImg() {
  return fetch({
    url: '/api/artificial/abnl/user/auth/getCaptchaImage',
    method: 'get'
  })
}
